import { useEffect, useMemo, useState } from 'react';
import type { TabItem } from '../types';
import UnderlineTab from './UnderlineTab';

export interface UnderlineTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  size: 'small' | 'large';
  direction: 'horizontal' | 'vertical';
}

const styleMap = {
  small: {
    horizontal: {
      tabs: 'flex flex-end border-b border-gray-300',
    },
    vertical: {
      tabs: 'flex flex-col',
    },
  },
  large: {
    horizontal: {
      tabs: 'flex space-x-6 border-b border-gray-300 justify-evenly md:justify-normal',
    },
    vertical: {
      tabs: 'flex flex-col space-y-4',
    },
  },
};

export const UnderlineTabs = ({
  tabs,
  activeTab,
  onTabChange,
  size = 'small',
  direction = 'horizontal',
}: UnderlineTabsProps) => {
  const styles = useMemo(() => {
    return styleMap[size][direction];
  }, [size, direction]);

  return (
    <ul className={styles.tabs}>
      {tabs.map((tab) => (
        <UnderlineTab
          key={tab.id}
          onClick={() => {
            onTabChange(tab.id);
          }}
          active={activeTab === tab.id}
          direction={direction}
          size={size}
        >
          {tab.label}
        </UnderlineTab>
      ))}
    </ul>
  );
};

export default UnderlineTabs;
